(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fo-site-header"]) return;
  try {
    
const foStickyHeader = document.querySelector('body.fo-home-original-type #header-group');
if (foStickyHeader) {
  const foStickyScroller = foStickyHeader.closest('.page-wrapper');
  if (foStickyScroller) {
    const updateFoStickyHeight = () => {
      foStickyScroller.style.setProperty('--fo-sticky-header-height', foStickyHeader.offsetHeight + 'px');
    };
    updateFoStickyHeight();
    new ResizeObserver(updateFoStickyHeight).observe(foStickyHeader);
  }
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
